module.exports = __webpack_public_path__ + "img/toplogo.5c92213a.jpg";